export const Bio = {
  name: "Ido Sulam",
  roles: ["Embedded Software Developer", "Low Level Developer", "Programmer"],
  description:
    "Embedded software developer focused on low-level systems, Linux, networking, and cybersecurity. I build reliable software for real-world systems, from bare-metal and RTOS work to automation, tooling, and research-driven projects. I enjoy solving complex technical problems, learning quickly, and turning ideas into practical, high-impact solutions.",
  github: "https://github.com/idosulam",
  resume: "not yet implemented",
  linkedin: "https://www.linkedin.com/in/ido-sulam-a3993b296/",
  twitter: "",
  insta: "",
  facebook: "",
};

export const skills = [
  {
    title: "Embedded & Low-Level",
    skills: [
      { name: "C" },
      { name: "C++" },
      { name: "Linux" },
      { name: "Networking" },
      { name: "Python" },
      { name: "RTOS" },
    ],
  },
  {
    title: "Systems & Security",
    skills: [
      { name: "Cybersecurity" },
      { name: "Linux" },
      { name: "Networking" },
      { name: "Docker" },
      { name: "GitHub" },
      { name: "Git" },
    ],
  },
  {
    title: "AI & Developer Tools",
    skills: [
      { name: "Cursor" },
      { name: "Claude Code" },
      { name: "GitHub Copilot" },
      { name: "LLMs" },
      { name: "Prompt Engineering" },
      { name: "AI Automation" },
    ],
  },
  {
    title: "Programming Languages",
    skills: [
      { name: "C" },
      { name: "C++" },
      { name: "Python" },
      { name: "Java" },
      { name: "C#" },
      { name: "JavaScript" },
    ],
  },
  {
    title: "Tools & Workflow",
    skills: [
      { name: "React Js" },
      { name: "Node Js" },
      { name: "MySQL" },
      { name: "Flask" },
      { name: "Express" },
      { name: "Rest API" },
      { name: "Git" },
      { name: "VS Code" },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "",
    role: "IT Specialist & Automation",
    company: "KPMG",
    date: "Mar 2026 - Present",
    desc: "IT operations specialist focusing on process automation and infrastructure. Developing Bash automation scripts for enterprise PC onboarding and cloud data management. Providing Tier 1/2 technical support and developing AI-powered solutions for operational efficiency.",
    bullet: [
      "Automated new-user PC setup with a Bash script, cutting onboarding time by ~50%.",
      "Engineered a parallel Bash backup-and-cloud-export script leveraging full CPU capacity, reducing 100GB transfer time by ~85%.",
      "Developing an AI-powered onboarding agent to assist new interns during their first days, reducing dependency on senior staff.",
      "Provided Tier 1/2 technical support to end users across a US-domain enterprise environment, resolving hardware, software, and network issues.",
    ],
    skills: [
      "Bash",
      "Automation",
      "Cloud",
      "AI",
      "Technical Support",
      "Enterprise IT",
    ],
    doc: "link",
  },
  {
    id: 1,
    img: "",
    role: "Private Tutor",
    company: "Study Hall",
    date: "Dec 2023 - present",
    desc: "working with all ages from middle school to university students Computer Science and Software",
    skills: ["Communication", "C", "C#", "Java", "Software Development"],
    bullet: [],
    doc: "link",
  },
  {
    id: 2,
    img: "",
    role: "Embedded software developer",
    company: "IAF",
    date: "Mar 2022 - Jul 2024",
    desc: "software developer at cybersecurity R&D labs. Embedded programming in C. developing a DPI Military product. working on Baremetal & RTOS projects.",
    bullet: [
      "Designed and delivered a proxy-based DPI system on a proprietary POSIX OS — the primary network inspection layer for a classified operational environment.",
      "Managed and improved projects through complete lifecycle including concept phase, planning, design, development, deployment, and on-site support.",
      "Built secure modular and abstracted backend architecture ensuring system stability, smooth operation and consistent performance across multiple environments.",
      "Refactored core logic from a monolithic dictionary into a modular multi-file architecture with proper abstraction layers, enabling future support for device types beyond DPI without core changes.",
      "Eliminated silent performance drain where failed value lookups triggered continuous exception handling — replaced with explicit edge-case logic and per-device mapping for instant failure identification.",
      "Designed and implemented Docker-based architecture serving dual purposes: a calibration process to identify and map each DPI device on the network, and secure middleware containers handling all user interactions.",
      "Provided real-time technical support and troubleshooting for operational control room personnel and field units.",
    ],
    skills: ["C", "Python", "Linux", "Networking", "Docker", "DPI Systems"],
    doc: "link",
  },
];

export const education = [
  {
    id: 0,
    img: "",
    school: "IAF - Israeli Air Force",
    date: "2024",
    grade: "",
    desc: "Completed an intensive 2-year program as a Software Engineer with Honors in a classified military environment, developing advanced low-level systems and network security solutions.",
    degree: "Software Engineer with Honors",
  },
  {
    id: 1,
    img: "",
    school: "ORT College",
    date: "Sep 2021 - June 2023",
    grade: "",
    desc: "Completed a comprehensive degree program in Software Engineering, gaining strong foundation in software design and development methodologies.",
    degree: "Software Practical Engineer with Honors",
  },
  {
    id: 2,
    img: "",
    school: "Madaim High School",
    date: "Sep 2018 - June 2021",
    grade: "",
    desc: "Successfully completed a demanding 12-year education program, majoring in Software Engineering with high honors. Equipped with strong foundation in principles of software design and development methodologies.",
    degree: "Software Engineer with High Honors",
  },
];

export const certifications = [
  {
    id: 0,
    title: "Introduction to GitHub",
    issuer: "Microsoft",
    date: "May 2026",
    description:
      "Comprehensive training in GitHub fundamentals, version control, collaboration workflows, and best practices for modern software development.",
    credentialUrl:
      "https://learn.microsoft.com/en-us/users/idosulam-0423/achievements/8vf34hjw",
  },
  {
    id: 1,
    title: "Introduction to Generative AI and Agents",
    issuer: "Microsoft",
    date: "May 2026",
    description:
      "In-depth introduction to generative AI concepts, large language models, and building intelligent AI agents for automation and problem-solving.",
    credentialUrl:
      "https://learn.microsoft.com/en-us/users/idosulam-0423/achievements/8vf3p4rw",
  },
  {
    id: 2,
    title: "Introduction to Cybersecurity",
    issuer: "Cisco",
    date: "Apr 2026",
    description:
      "Foundational cybersecurity principles covering network security, threat detection, defense strategies, and security best practices.",
    credentialUrl:
      "https://www.credly.com/badges/b9cdf385-7d89-4545-9f45-97938b022524/linked_in_profile",
  },
];

export const projects = [
  {
    id: 0,
    title: "Advance Code search engine",
    date: " Sep 2022 - May 2023",
    description:
      "Built a full-stack code-search platform designed to help users understand project structure and navigate large codebases faster. The system combines a visual workflow explorer with a search engine for code discovery, making it easier to locate relevant files, relationships, and logic across a project.",
    image: "Advance Code search engine",
    tags: ["React Js", "MYSQL", "Node Js", "Python", "Flask"],
    category: "Web App",
    github: "https://github.com/idosulam/lexer",
    member: [
      {
        name: "Ido Sulam",
        img: "",
        github: "https://github.com/idosulam",
        linkedin: "https://www.linkedin.com/in/ido-sulam-a3993b296/",
      },
    ],
  },
  {
    id: 1,
    title: "Hospital Management System",
    date: " Nov 2023 - Dec 2023",
    description:
      "Developed a hospital management application to streamline patient, scheduling, and operational workflows in a healthcare environment. The project focused on efficient data handling, modular system design, and improving accessibility of core hospital functions through a collaborative team-based development process.",
    image: "Hospital Management System",
    tags: ["C++"],
    category: "Stealth",
    github: "",
    member: [
      {
        name: "Ido Sulam",
        img: "",
        github: "https://github.com/idosulam",
        linkedin: "https://www.linkedin.com/in/ido-sulam-a3993b296/",
      },
    ],
  },
  {
    id: 2,
    title: "Keylogger",
    date: "Research Project",
    description:
      "Developed a Linux kernel-based keylogger that intercepts keyboard events through kernel modules and netlink sockets. The project demonstrates practical experience with low-level system programming, IPC between kernel and userspace, and raw packet construction for data exfiltration, while also reinforcing a deeper understanding of Linux internals and defensive security principles.",
    image: "Keylogger",
    tags: ["C", "Linux Kernel", "Netlink", "Networking", "Cybersecurity"],
    category: "Systems Programming",
    github: "https://github.com/idosulam/keylogger",
    member: [
      {
        name: "Ido Sulam",
        img: "",
        github: "https://github.com/idosulam",
        linkedin: "https://www.linkedin.com/in/ido-sulam-a3993b296/",
      },
    ],
  },
];
